/**
 * @fileoverview CSS module for styling list sections with icons and text
 * Used for rendering vertical lists with icons and text content
 *
 * @example
 * // Usage in component:
 * import styles from './List.module.css';
 *
 * <ul className={styles.list}>
 *   <li>
 *     <img className={styles.list_icon} src="icon.svg" alt="Icon" />
 *     <div className={styles.text}>List item text</div>
 *   </li>
 * </ul>
 */


.list {
    list-style-type: none;
    line-height: 2em;
    padding: 0;
    margin: 0.25rem 0 0;
}

.list li {
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
    line-height: 1.5rem;
    color: var(--neutural900);
    gap: 1rem;
}

.list li:last-of-type {
    padding-bottom: 0px;
}

.list_icon {
    object-fit: none;
    object-position: 0px 0px;
    width: 2rem;
    height: 2rem;
}

.text {
    font-size: 18px;
}
